import React, { useState } from 'react';
import { Check, Loader2 } from 'lucide-react';
import { STRIPE_PRODUCTS } from '../stripe-config';

interface PricingCardProps {
  onSubscribe: (priceId: string) => Promise<void>;
}

export function PricingCard({ onSubscribe }: PricingCardProps) {
  const [loading, setLoading] = useState<string | null>(null);

  const handleSubscribe = async (priceId: string) => {
    setLoading(priceId);
    try {
      await onSubscribe(priceId);
    } catch (error) {
      console.error('Subscription error:', error);
    } finally {
      setLoading(null);
    }
  };

  const features = [
    'Unlimited countdowns',
    'Custom photos',
    'Advanced reminders',
    'Calendar view',
    'Priority support'
  ];

  return (
    <div className="max-w-md mx-auto">
      {STRIPE_PRODUCTS.map((product) => (
        <div key={product.priceId} className="bg-white rounded-2xl shadow-xl border border-gray-200 p-8">
          <div className="text-center mb-8">
            <h3 className="text-2xl font-bold text-gray-900 mb-2">{product.name}</h3>
            <div className="flex items-center justify-center mb-4">
              <span className="text-4xl font-bold text-gray-900">${product.price}</span>
              <span className="text-gray-500 ml-2">/month</span>
            </div>
            <p className="text-gray-600">{product.description}</p>
          </div>

          <ul className="space-y-4 mb-8">
            {features.map((feature, index) => (
              <li key={index} className="flex items-center">
                <Check className="h-5 w-5 text-green-500 mr-3 flex-shrink-0" />
                <span className="text-gray-700">{feature}</span>
              </li>
            ))}
          </ul>

          <button
            onClick={() => handleSubscribe(product.priceId)}
            disabled={loading === product.priceId}
            className="w-full bg-indigo-600 text-white py-3 px-6 rounded-lg font-semibold hover:bg-indigo-700 transition-colors disabled:opacity-50 disabled:cursor-not-allowed flex items-center justify-center"
          >
            {loading === product.priceId ? (
              <>
                <Loader2 className="h-5 w-5 animate-spin mr-2" />
                Processing...
              </>
            ) : (
              'Subscribe Now'
            )}
          </button>
        </div>
      ))}
    </div>
  );
}